import { render, staticRenderFns } from "./TaxReturnSections.vue?vue&type=template&id=49bd3918&scoped=true&"
import script from "./TaxReturnSections.vue?vue&type=script&lang=js&"
export * from "./TaxReturnSections.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnSections.vue?vue&type=style&index=0&id=49bd3918&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd3918",
  null
  
)

export default component.exports